import { createLogger } from "../utils";
import { ATS_VERSION } from "./constants/version";
class AdtechStackCore {
    constructor(site, stackVersion) {
        this.services = {};
        this.site = site;
        this.stackVersion = stackVersion;
        this.coreVersion = ATS_VERSION;
        this.context = {
            services: this.services,
            core: {
                site,
                stackVersion,
                coreVersion: ATS_VERSION,
            },
        };
        this.logger = createLogger("ats-core");
    }
    async start() {
        this.logger.logInfo(`Start ATS for ${this.site} v.${this.stackVersion} (Core v.${this.coreVersion})`);
    }
}
export default AdtechStackCore;
//# sourceMappingURL=ats.js.map